import request from '@/utils/request'

/**
 * 发送补充数据信息
 * @param {string} uuid elink的uuid
 * @param {number} dataRange 补录范围
 * @param {string} startTime 开始时间
 * @param {string} endTime 结束时间
 * @param {string} remark 备注
 * @returns
 */
export function rePush(uuid, dataRange, startTime, endTime, remark) {
  return request({
    method: "POST",
    url: "/command/rePush",
    data: {
      uuid,
      dataRange,
      startTime,
      endTime,
      remark
    },
  })
}

/**
 * 查询补录日志列表
 * @param {string} stationId 电站Id
 * @param {string} uuid elink的uuid
 * @param {string} startTime 开始时间
 * @param {string} endTime 	结束时间
 * @param {string} state 状态 `none some all error running`
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页显示数量
 * @returns
 */
export function rePushList(stationId, uuid, startTime, endTime, state, pageNum, pageSize) {
  return request({
    method: "GET",
    url: "/command/rePush/list",
    params: {
      stationId,
      uuid,
      startTime,
      endTime,
      state,
      pageNum,
      pageSize
    },
  })
}



/**
 * 删除单条补录日志
 * @param {string} id 主键ID
 * @returns
 */
export function delRePushLog(id) {
  return request({
    method: "DELETE",
    url: `command/rePush/${id}`,
  })
}

/**
 * 获取能量链温度参数
 * @param {string} device_uuid 
 * @returns 
 */
export function getTempatureOption(device_uuid) {
  return request({
    method: "GET",
    url: `/command/device/data/setting`,
    params: {
      uuid: device_uuid
    }
  })
}


/**
 * 设置能量链温度参数
 * @param {object} alarm 
 * @param {string} alarm.equipmentuuid 
 * @returns 
 */
export function setTempatureOption(data) {

  // 删除空值
  let postData = {}
  Object.keys(data).forEach(key => {
    let value = data[key]
    if (value != null && value != '') {
      postData[key] = value
    }
  })

  return request({
    method: "POST",
    url: `/command/device/command/setting`,
    data: postData,
  })
}

/**
 * 能量链温度参数设置历史
 */
export function getTempatureRecord({
  stationId,
  uuid,
  startTime,
  endTime,
  pageNum,
  pageSize
}) {
  return request({
    method: "GET",
    url: '/command/record/data/set/list',
    params: {
      stationId,
      uuid,
      startTime,
      endTime,
      pageNum,
      pageSize,
    }
  })
}

/**
 * 参数设置
 */
export function commandSetting(data) {
  return request({
    method: "POST",
    url: '/command/device/command/setting',
    data: data,
  })
}
